import { Accordion, AccordionSection, Text } from '@asurion-core/mx-asurion-ui-react';
import styled from 'styled-components';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { a11yDark } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { usePlaygroundStore } from '../storage';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const ScriptCodeSnippetBasic = () => {
  const widgetParams = usePlaygroundStore((state) => state.widgetParams);

  const codeString = `<script async src="${
    process.env.NX_PUBLIC_WIDGET_LOADER_URL
  }" data-widget-id="${widgetParams?.id ?? '{{ widget-id }}'}" data-variant="${
    widgetParams?.variant ?? '{{ variant }}'
  }" />`;

  return (
    <SyntaxHighlighter language="javascript" style={a11yDark} wrapLines wrapLongLines>
      {codeString}
    </SyntaxHighlighter>
  );
};

const ScriptCodeSnippetWithOverrides = () => {
  const widgetParams = usePlaygroundStore((state) => state.widgetParams);

  const codeString = `<script>
  (function (w, d, s, o, f, a, js, fjs) {
    w[o] =
      w[o] ||
      function () {
        const [action, ...params] = arguments;
        (w[o].q = w[o].q || []).push([action, ...params]);
      };
    (js = d.createElement(s)), (fjs = d.getElementsByTagName(s)[0]);
    js.id = o;
    js.src = f;
    js.async = 1;
    js.setAttribute('data-widget-id', a.id);
    js.setAttribute('data-variant', a.variant);
    w[\`\${o}_context\`] = a.context;
    w[\`\${o}_options\`] = a.variantOptionOverrides;
    fjs.parentNode.insertBefore(js, fjs);
  })(window, document, 'script', '_si_widget', '${process.env.NX_PUBLIC_WIDGET_LOADER_URL}', {
    id: '${widgetParams?.id ?? '{{ widget-id }}'}',
    variant: '${widgetParams?.variant ?? '{{ variant }}'}',
    ${
      widgetParams?.variantOptionOverrides?.[widgetParams?.variant]
        ? `variantOptionOverrides: {
      '${widgetParams?.variant}': ${`{
        ${Object.entries(widgetParams?.variantOptionOverrides?.[widgetParams?.variant] ?? {})
          .map(([key, value]) => {
            return `'${key}': ${typeof value === 'string' ? value : JSON.stringify(value)}`;
          })
          .join(',\n      ')}
      }`}
    }`
        : ''
    }
  });
</script>`;

  return (
    <SyntaxHighlighter language="javascript" style={a11yDark} wrapLines wrapLongLines>
      {codeString}
    </SyntaxHighlighter>
  );
};

export const ScriptIntegration = () => {
  const widgetParams = usePlaygroundStore((state) => state.widgetParams);

  return (
    <Container>
      <Text size={2} as="p">
        The SI Widget can be dropped into any webpage with a simple script tag and a few configuration options.
      </Text>
      {widgetParams?.variantOptionOverrides ? <ScriptCodeSnippetWithOverrides /> : <ScriptCodeSnippetBasic />}
      <Accordion>
        <AccordionSection header="Example script tag integration with no overrides" tabIndex={-1}>
          <ScriptCodeSnippetBasic />
        </AccordionSection>
        <AccordionSection header="Example script tag integration with overrides included" tabIndex={-1}>
          <ScriptCodeSnippetWithOverrides />
        </AccordionSection>
      </Accordion>
    </Container>
  );
};
